import type { FeatureFlag } from 'api/contentful/contentTypes.cloverdotcom';
import { ContentType } from 'api/contentful/contentTypes.cloverdotcom';
import { useAllContentfulEntries } from 'hooks/useAllContentfulEntries';
import { Environment } from '../../utils/Environment';

export function useFeatureFlagsInternal() {
  const entries = useAllContentfulEntries<FeatureFlag>(ContentType.FEATURE_FLAG);

  const setFeatureFlagBasedOnEnvironment = () => {
    if (!entries?.data) return new Map<string, boolean>();

    const map = new Map<string, boolean>();

    entries.data.forEach(entry => {
      if (!entry.key) return;

      let value = false;

      if (Environment.current.isCloverProdEnvironment) value = !!entry.production;
      if (Environment.current.isCloverStagingEnvironment) value = !!entry.staging;
      if (Environment.current.isCloverDevEnvironment) value = !!entry.development;
      if (Environment.current.isLocalhost) value = !!entry.localhost;

      map.set(entry.key, value);
    });

    return map;
  };

  const featureFlags = setFeatureFlagBasedOnEnvironment();

  return {
    isFlagEnabled: (key: string) => !!featureFlags.get(key),
    isFetched: entries.isFetched,
  };
}
